import React from "react";
import styled from "@emotion/styled";

const LogoContainer = styled.div`
  align-self:center;
  position: relative;
  min-height: 50px;
`;

export class Logo extends React.Component {
    constructor(props) {
        super(props);
    }
        
    render() {
        const width = this.props.width ? this.props.width : 120,
              height = this.props.height ? this.props.height: 47,
              link = this.props.link ? this.props.link : '/';
        
        return (
            <LogoContainer className={(this.props.className ? this.props.className : '')}>
                <a href={link}><img src={(this.props.searchURLBase ? this.props.searchURLBase : '') + "/assets/img/front/icons/cvm-logo-primary.svg"} width={width} height={height} alt="logo"/></a>
            </LogoContainer>
        );
    }
}

